// extracted by mini-css-extract-plugin
export var category = "_j7-9";
export var categoryHeader = "_j7-e";
export var container = "_j7-0";
export var group = "_j7-a";
export var groupItems = "_j7-f";
export var groupSeparator = "_j7-j";
export var loading = "_j7-1";
export var noResults = "_j7-3";
export var placeholder = "_j7-2";
export var resultContent = "_j7-5";
export var resultIcon = "_j7-c";
export var resultItem = "_j7-g";
export var resultMeta = "_j7-8";
export var resultSubtitle = "_j7-7";
export var resultSuffix = "_j7-i";
export var resultTitle = "_j7-6";
export var resultsList = "_j7-4";
export var searchGroup = "_j7-d";
export var selected = "_j7-h";
export var subgroup = "_j7-b";